import { RubriquesBlog } from '@components/rubriques-blog/models';
import { Block } from '@shared/models';

export const rubriquesBlogMock: Block<RubriquesBlog> = {
  type: 'rubriques-blog',
  data: {
    title: { text: 'Les sujets', as: 'h2' },
  },
};
